import React from "react";
import { Typography } from "@timeedit/ui-components/antd";
import Language from "../../lib/Language";
import { TComponent } from "../../types/utils";
import { formatActivityDate } from "./ActivityDateTime.utils";

type TDateColumnProps = {
    title: string;
    value: string | number;
    timeZone?: string;
};

const DateColumn: TComponent<TDateColumnProps> = ({ title, value, timeZone }) => (
    <div>
        <Typography.Text style={{ fontSize: "0.8rem", color: "inherit", opacity: 0.65 }}>
            {title}
        </Typography.Text>
        <div>{formatActivityDate(value, timeZone)}</div>
    </div>
);

type TDateRangesValueProps = {
    startTime?: string | number | null;
    endTime?: string | number | null;
    /** IANA identifier, for example "Europe/Stockholm". */
    timeZone?: string;
};

/** An activity's start and end dates side by side, in its time zone. */
export const DateRangesValue: TComponent<TDateRangesValueProps> = ({
    startTime,
    endTime,
    timeZone,
}) => (
    <div style={{ display: "flex", gap: "0.5rem" }}>
        {startTime ? (
            <DateColumn
                title={Language.get("nc_activity_start")}
                value={startTime}
                timeZone={timeZone}
            />
        ) : null}
        {endTime ? (
            <DateColumn
                title={Language.get("nc_activity_end")}
                value={endTime}
                timeZone={timeZone}
            />
        ) : null}
    </div>
);
